import {Repository, createRepository} from '@/repositories/Base/Repository'

class IntegrationHelperRepository extends Repository {
    endpoint = 'integration/helper'

    fetchAll(params) {
        return this.$axios.get(`${this.endpoint}`, {params})
    }

    fetch(id) {
        return this.$axios.get(`${this.endpoint}/${id}`)
    }

    post(params) {
        return this.$axios.post(`${this.endpoint}`, params)
    }

    put(id, params) {
        return this.$axios.put(`${this.endpoint}/${id}`, params)
    }
}

export default new IntegrationHelperRepository()

export const create = createRepository(IntegrationHelperRepository)
